import { Box, Container, useColorModeValue } from "@chakra-ui/react";
import "./Footer.css";

export interface IFooterProps {}
export default function Footer(props: IFooterProps) {
  return (
    <Box w="100%" p={4} className="footer">
      FG - FI - SL | Taller integrador 2021
    </Box>
  );
}
